module.exports = __webpack_public_path__ + "img/audiovisual.799033d4.jpg";